import script from "./CarePackageLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./CarePackageLanding.vue?vue&type=script&setup=true&lang=js"

import "./CarePackageLanding.vue?vue&type=style&index=0&id=ccba5b24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccba5b24"]])

export default __exports__